<div class="collection-container">
    @for (item of inputValue; track trackByIndex(i, item); let i = $index) {
        <div [@fadeIn]="!!item.__created" [class.dim]="fade === i" class="collection-rows">
            <form #itemForm="ngForm" ngForm [class.removable]="view.vars.allow_delete">
                <sf-form
                    name="value"
                    [view]="view.children[i] || view.vars.prototype"
                    [(ngModel)]="inputValue[i]"
                    [renderAll]="true"
                    (ngModelChange)="onInputChange()"
                    [fields]="['action', 'involved']"
                ></sf-form>
                @if (inputValue[i]?.action?.name?.toLowerCase() === 'called police' || inputValue[i]?.action?.name?.toLowerCase() === 'called ambulance') {
                    <sf-form
                        class="promis"
                        name="value"
                        [view]="view.children[i] || view.vars.prototype"
                        [(ngModel)]="inputValue[i]"
                        [renderAll]="true"
                        (ngModelChange)="onInputChange()"
                        [fields]="['promisNumber']"
                    ></sf-form>
                }
                @if (view.vars.allow_delete) {
                    <div class="collection-remove-wrapper">
                        <button type="button" class="btn btn-danger collection-remove" (click)="removeItem(i)" (mouseover)="fade = i" (mouseleave)="fade = null">
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                }
            </form>
            <hr />
        </div>
    }
    @if (view.vars.allow_add) {
        <div class="d-flex">
            <button type="button" class="btn btn-gray mt-1 mb-0" style="width: 100%" (click)="addItem()"><i class="fa fa-plus"></i> {{ view.vars.attr.add_label || 'Add' }}</button>
        </div>
    }
</div>
